export enum TypeListFormValue {
  DESCRIPTION = 'Description',
}
